import React from 'react';
import { Button } from '@grubhubprod/gh-cookbook-react';
import { buildCAUIPath, CAUIPage } from 'src/constants/urls';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { FeatureFlag } from 'src/types/FeatureFlag';

interface BulkUploadEmployeesButtonProps {
  corpId: string;
  setIsBulkUploadDialogOpen: (isOpen: boolean) => void;
}

export const BULK_UPLOAD_BUTTON_TEXT = 'Upload employees in bulk';

export function BulkUploadEmployeesButton({
  corpId,
  setIsBulkUploadDialogOpen,
}: BulkUploadEmployeesButtonProps): JSX.Element {
  const { value: isNewEmployeesBulkUploadPageEnabled } = useFeatureFlag(
    FeatureFlag.ENABLE_NEW_EMPLOYEES_BULK_UPLOAD_PAGE
  );

  if (!isNewEmployeesBulkUploadPageEnabled) {
    return (
      <Button
        href={buildCAUIPath(CAUIPage.EMPLOYEES_UPLOAD, { corpId })}
        variant="secondary"
        buttonSize="medium"
        as="a"
      >
        {BULK_UPLOAD_BUTTON_TEXT}
      </Button>
    );
  }

  return (
    <Button
      variant="secondary"
      buttonSize="medium"
      onClick={(): void => {
        setIsBulkUploadDialogOpen(true);
      }}
    >
      {BULK_UPLOAD_BUTTON_TEXT}
    </Button>
  );
}
